import { render, staticRenderFns } from "./APP_recruitList.vue?vue&type=template&id=068ab214&scoped=true&"
import script from "./APP_recruitList.vue?vue&type=script&lang=js&"
export * from "./APP_recruitList.vue?vue&type=script&lang=js&"
import style0 from "./APP_recruitList.vue?vue&type=style&index=0&id=068ab214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ab214",
  null
  
)

export default component.exports